import {useSnackbar, OptionsObject} from 'notistack'

export const useSnackBar = () => {
    return useSnackbar()
}